'use client';

import { FC } from 'react';
import { useUser } from 'modules/shop/user/hooks';
import { AccountView } from './AccountView';
import { LoginContent } from './LoginContent';

export const LoginPopupContent: FC = () => {
  const { user } = useUser();

  return !!user ? <AccountView /> : <LoginContent />;
};
